exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-item.active-item[data-v-5b911aaa]{color:var(--v-secondary-base)!important}", ""]);

// exports
